<!-- =========================================================================================
    File Name: Register.vue
    Description: Register Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row no-gutter">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/register.jpg" alt="register" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title">
                                    <h4 class="mb-4">创建账号</h4>
                                    <p>快速创建一个账号去参加比赛吧.</p>
                                </div>
                                <div class="clearfix">
                                    <vs-input
                                        v-validate="'required|alpha_dash|min:3'"
                                        data-vv-validate-on="blur"
                                        label-placeholder="用户名"
                                        name="username"
                                        placeholder="用户名"
                                        v-model="username"
                                        class="w-full" />
                                    <span class="text-danger text-sm">{{ errors.first('username') }}</span>

                                    <vs-input
                                        ref="password"
                                        type="password"
                                        data-vv-validate-on="blur"
                                        v-validate="'required|min:6|max:18'"
                                        name="password"
                                        label-placeholder="密码"
                                        placeholder="密码"
                                        v-model="password"
                                        class="w-full mt-6" />
                                    <span class="text-danger text-sm">{{ errors.first('password') }}</span>

                                    <vs-input
                                        type="password"
                                        v-validate="'min:6|max:18|confirmed:password'"
                                        data-vv-validate-on="blur"
                                        data-vv-as="password"
                                        name="confirm_password"
                                        label-placeholder="确认密码"
                                        placeholder="确认密码"
                                        v-model="confirm_password"
                                        class="w-full mt-6" />
                                    <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>

                                    <vs-checkbox v-model="isTermsConditionAccepted" class="mt-6">我接受Match赛事平台相关条款和协议</vs-checkbox>
                                    <vs-button  type="border" to="/pages/login" class="mt-6">登录</vs-button>
                                    <vs-button class="float-right mt-6" @click="registerUser" :disabled="!validateForm">注册</vs-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>

import { Validator } from 'vee-validate'

const dict = {
    custom: {
        username: {
            required: '请输入你的用户名',
            alpha_dash: '你的用户名不能包含特殊字符，允许的字符字母及数字',
            min: '用户名不能小于三个字符'
        },
        password: {
            required: '请输入你的密码',
            min: '密码的长度小于6',
            max: '密码的长度不能大于18'
        },
        confirm_password: {
            confirmed: '两次输入的密码不一致',
            min: '密码的长度小于6',
            max: '密码的长度不能大于18'
        }
    }
}

Validator.localize('zh', dict)

export default {
    data() {
        return {
            username: '',
            password: '',
            confirm_password: '',
            isTermsConditionAccepted: true
        }
    },
    computed: {
        validateForm() {
            return !this.errors.any() && this.username != '' && this.password != '' && this.confirm_password != '' && this.isTermsConditionAccepted === true;
        }
    },
    methods: {
        registerUser() {
            if (!this.validateForm) return false
            if(this.$store.state.auth.isUserLoggedIn()) {
              this.notifyAlreadyLogedIn();
              return
            }
            const payload = {
              userDetails: {
                password: this.password,
                username: this.username
              },
              notify: this.$vs.notify
            }
            this.$store.dispatch('auth/registerUser', payload)
        },
        notifyAlreadyLogedIn() {
            this.$vs.notify({
                title: 'Login Attempt',
                text: '你已经登录！',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            });
        },
    }
}
</script>
